// extracted by mini-css-extract-plugin
module.exports = {"popUp":"LoginSuccessPopup_popUp__3QfWs","title":"LoginSuccessPopup_title__3oyGg","dialogBtn":"LoginSuccessPopup_dialogBtn__1Wda-","ok":"LoginSuccessPopup_ok__2yMjT"};